import { Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';

@Component({
  standalone: true,
  imports: [MatDialogModule, MatButtonModule],
  selector: 'app-dialog-elimina',
  templateUrl: './dialog-elimina.component.html',
  styleUrls: ['./dialog-elimina.component.scss']
})
export class DialogEliminaComponent {
  constructor(public dialogRef: MatDialogRef<DialogEliminaComponent>) {}

  chiudiDialog(response) {
    this.dialogRef.close(response);
  }
}
